import {
  calendarDate_default,
  formatCalendarDate,
  formatCalendarDateDayMonth,
  formatCalendarDateDayMonthLong,
  formatCalendarDateLong,
  formatCalendarDateLongMonth,
  formatCalendarDateMonthYear,
  formatCalendarDateMonthYearLong,
  formatCalendarDateShort,
  formatCalendarDateShortMonth,
  formatCalendarDateWeekday,
  formatCalendarDateWeekdayShort,
  formatDate,
  formatDateLong,
  formatDateShort,
  formatDateTime,
  formatDayMonth,
  formatDayMonthLong,
  formatExchangeRate,
  formatFloat,
  formatInt,
  formatLongMonth,
  formatLongMonthFromIdx,
  formatMoney,
  formatMonthYear,
  formatMonthYearLong,
  formatPercent,
  formatShortMonth,
  formatShortMonthFromIdx,
  formatTime,
  formatWeekday,
  formatWeekdayShort,
  isBankDay,
  nextBankDay,
  numberSettings,
  prevBankDay,
  r,
  res,
  toFloat,
  toInt
} from "./chunk-P5TPVON7.mjs";

// src/formatPhoneNumber.ts
var formatPhoneNumber = ({
  phoneNumber,
  locale
}) => {
  if (!phoneNumber) {
    return "";
  }
  let phoneNumberTarget = phoneNumber.toString().replace(" ", "");
  if (locale === "is") {
    if (phoneNumberTarget.length > 7 && phoneNumberTarget.length <= 10) {
      return `${phoneNumberTarget.substring(phoneNumberTarget.length - 7, phoneNumberTarget.length - 4)} ${phoneNumberTarget.substring(phoneNumberTarget.length - 4, phoneNumberTarget.length)}`;
    }
    if (phoneNumberTarget.length > 7) {
      phoneNumberTarget = phoneNumberTarget.replace(/\+\d{3}/, "");
    }
    if (phoneNumberTarget.length === 7) {
      phoneNumberTarget = `${phoneNumberTarget.substring(0, 3)} ${phoneNumberTarget.substring(3)}`;
    }
    return phoneNumberTarget;
  } else {
    phoneNumberTarget = phoneNumberTarget.replace(/^\+/, "");
    const countryCode = phoneNumberTarget.substring(0, 3);
    const restNumber = phoneNumberTarget.substring(3);
    if (phoneNumberTarget.length === 7) {
      return `+354 ${phoneNumberTarget.substring(0, 3)} ${phoneNumberTarget.substring(3)}`;
    }
    if (phoneNumberTarget.length > 7 && phoneNumberTarget.length < 10) {
      return phoneNumberTarget;
    }
    return `+${countryCode} ${restNumber.substring(0, 3)} ${restNumber.substring(3)}`;
  }
};

// src/getAcceptLanguageByLocale.ts
var getAcceptLanguageByLocale = (locale) => {
  switch (locale) {
    case "en":
      return "en-GB";
    case "pl":
      return "pl-PL";
    case "is":
    default:
      return "is-IS";
  }
};

// src/higherOrderResource.tsx
import React2 from "react";

// src/useResource.ts
import React, { useContext } from "react";

// src/LocaleContext.tsx
import { createContext } from "react";
var LocaleContext = createContext({
  locale: "is",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setLocale: () => {
  }
});

// src/useResource.ts
var useResource = () => {
  const { locale, setLocale } = useContext(LocaleContext);
  return React.useMemo(
    () => ({
      locale,
      setLocale,
      r: res(locale)
    }),
    [locale, setLocale]
  );
};

// src/higherOrderResource.tsx
function resource(Component) {
  const hocComp = (props) => {
    const { locale, r: r2 } = useResource();
    return /* @__PURE__ */ React2.createElement(Component, { ...props, locale, r: r2 });
  };
  return hocComp;
}

// src/Locale.tsx
import React3, { useState } from "react";
var isLocaleType = (locale) => {
  return locale === "is" || locale === "en" || locale === "pl";
};
var Locale = ({
  children,
  initialLocale = "is"
}) => {
  const [locale, setLocale] = useState(initialLocale);
  return /* @__PURE__ */ React3.createElement(LocaleContext.Provider, { value: { locale, setLocale } }, children);
};

// src/ietf.ts
function convertIetfLanguageTagToLocale(ietf) {
  let locale;
  if (ietf) {
    try {
      const c = ietf.split("-")[0];
      if (isLocaleType(c)) {
        locale = c;
      }
    } catch {
    }
  }
  return locale;
}
function convertLocaleToIetfLanguageTag(locale) {
  switch (locale) {
    case "en":
      return "en-GB";
    case "is":
      return "is-IS";
    case "pl":
      return "pl-PL";
  }
}

// src/localize.tsx
import * as React4 from "react";
function localize(Component) {
  const hocComp = (props) => {
    const { locale } = useResource();
    return /* @__PURE__ */ React4.createElement(Component, { ...props, locale });
  };
  return hocComp;
}

// src/useLocalize.ts
import React5, { useContext as useContext2 } from "react";
var useLocalize = () => {
  const { locale } = useContext2(LocaleContext);
  return React5.useMemo(
    () => ({
      locale
    }),
    [locale]
  );
};
export {
  calendarDate_default as CalendarDate,
  Locale,
  LocaleContext,
  convertIetfLanguageTagToLocale,
  convertLocaleToIetfLanguageTag,
  formatCalendarDate,
  formatCalendarDateDayMonth,
  formatCalendarDateDayMonthLong,
  formatCalendarDateLong,
  formatCalendarDateLongMonth,
  formatCalendarDateMonthYear,
  formatCalendarDateMonthYearLong,
  formatCalendarDateShort,
  formatCalendarDateShortMonth,
  formatCalendarDateWeekday,
  formatCalendarDateWeekdayShort,
  formatDate,
  formatDateLong,
  formatDateShort,
  formatDateTime,
  formatDayMonth,
  formatDayMonthLong,
  formatExchangeRate,
  formatFloat,
  formatInt,
  formatLongMonth,
  formatLongMonthFromIdx,
  formatMoney,
  formatMonthYear,
  formatMonthYearLong,
  formatPercent,
  formatPhoneNumber,
  formatShortMonth,
  formatShortMonthFromIdx,
  formatTime,
  formatWeekday,
  formatWeekdayShort,
  getAcceptLanguageByLocale,
  isBankDay,
  isLocaleType,
  localize,
  nextBankDay,
  numberSettings,
  prevBankDay,
  r,
  resource,
  toFloat,
  toInt,
  useLocalize,
  useResource
};
//# sourceMappingURL=index.mjs.map